import { createApp } from 'vue'
import App from './App.vue'
import router from './routes'
import './style.css'
import { permissionDirective } from './directives/permissionDirective'
import { usePermissions } from './composables/usePermissions'

const { initPermissions } = usePermissions()
initPermissions()

const app = createApp(App)

app.use(router)
app.directive('permission', permissionDirective)
app.mount('#app')
